import type { FetchLabOrdersParams } from '@lotushealth/lotushealth_js_sdk/schemas';
import type {
  SearchBiomarkersRequestT,
  SearchLabTestsRequestT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

/**
 * Query keys for Junction/Vital labs-related data.
 */
export const labsKeys = {
  all: ['labs'] as const,

  patientOrders: (userId: string, params?: FetchLabOrdersParams) =>
    ['labs', 'patient', userId, 'orders', ...(params ? [params] : [])] as const,

  labTestsSearch: (filters: SearchLabTestsRequestT) =>
    ['labs', 'tests', 'search', filters] as const,

  biomarkersSearch: (filters: SearchBiomarkersRequestT) =>
    ['labs', 'biomarkers', 'search', filters] as const,

  icd10Search: (query: string) => ['labs', 'icd10', 'search', query] as const,
};
